import { DEFAULT_GAIA_BASE_URL, ExperienceSession, buildSession, buildVoiceTurn } from '@aeonia/gaia-client';
import type { VoiceTurn } from '@aeonia/gaia-client';

export { fakeModeEnabled, FAKE_OPENING_LINE } from '@aeonia/gaia-client';

/** The dev gateway on the Tailscale network, overridable at build time. */
let gaiaBaseUrl: string = import.meta.env.VITE_GAIA_BASE_URL ?? DEFAULT_GAIA_BASE_URL;

/** Replaces the build-time gateway with the host's, before any session is built. */
export function setGaiaBaseUrl(url: string): void {
  gaiaBaseUrl = url;
}

/** Builds the session this page run will drive. See buildSession for the details. */
export function createSession(search: string = location.search): ExperienceSession {
  const phone = typeof document !== 'undefined' && document.getElementById('root')?.dataset.layout === 'phone';
  return buildSession({ baseUrl: gaiaBaseUrl, dev: import.meta.env.DEV, search, resumeByDefault: phone });
}

/** Builds the spoken turn for this page run, wired to the same session. */
export function createVoiceTurn(session: ExperienceSession, search: string = location.search): VoiceTurn {
  return buildVoiceTurn(session, { baseUrl: gaiaBaseUrl, dev: import.meta.env.DEV, search });
}
